import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wc2q3m3rxc: FaireBrandEntity = {
  token: "b_wc2q3m3rxc",
  type: "brand",
  name: "Hongar Farms",
  avatarUrl:
    "https://cdn.faire.com/fastly/5341e63d80598c9838b2b993e51a20693d9dceea6968ade0d96b9f2493f6b0f3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b11b205bc32a1ac4172ac826a4904ded7caafdd9f218b476c1d512e6f86da94d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5341e63d80598c9838b2b993e51a20693d9dceea6968ade0d96b9f2493f6b0f3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b11b205bc32a1ac4172ac826a4904ded7caafdd9f218b476c1d512e6f86da94d.png",
  location: "Tucker, GA, USA",
  minimumOrderDollars: 49,
  rating: 4.9,
  reviewCount: 158,
  isTopShop: true,
  isInsider: true,
  description:
    "At Hongar Farms, we craft gourmet infused oils designed to elevate every kitchen and inspire unforgettable meals. Blending tradition with modern culinary artistry, our small-batch cooking oils combine premium quality, farm-fresh herbs, and rich flavors that transform simple recipes into extraordinary creations.\n\nEach bottle of Hongar Farms oil is more than an ingredient—it’s an experience. From the warm, comforting aroma of roasted garlic to the bright, zesty notes of Sicilian citrus, our artisan infused oils add depth and character to everything from salads and pastas to grilled meats and fresh bread. Whether you’re a home chef experimenting with new recipes or looking for the perfect gourmet gift, our oils make every pour, drizzle, and dip something to savor.\n\nBeautifully designed to look as stunning on your countertop as they taste in your dishes, Hongar Farms bottles are functional works of art. Perfect for cooking, gifting, or entertaining, they bring elegance to every kitchen and joy to every meal.\n\nDiscover why food lovers everywhere are falling in love with Hongar Farms infused cooking oils—crafted to make every moment in the kitchen taste as good as it looks.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:51.925Z",
    importedBy: "entity-db-cli",
  },
};
